export default "__VITE_ASSET__6g_hVDg5__"